// Reachability probe for the self-hosted PMTiles basemap: one 1-byte range
// request against the tileset. If it can't answer quickly, MapView falls
// back to the Carto rasters instead of leaving users on a blank basemap.
// Deliberately load-time-only — reacting to individual mid-session tile
// errors would bounce people to Carto over a single dropped request.

export const PROBE_TIMEOUT_MS = 4000;

export async function probeTiles(url, { timeoutMs = PROBE_TIMEOUT_MS, fetchFn = fetch } = {}) {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetchFn(url, {
      headers: { Range: 'bytes=0-0' },
      signal: ctrl.signal,
    });
    return res.ok;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}
